import PositionsHistoryTable from "./PositionsHistoryTable";

const Employment = () => {
    return <PositionsHistoryTable />;
};

export default Employment;
